import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AlertContext } from "../../context/AlertContext";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonUnstyled from "@mui/base/ButtonUnstyled";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonMui from "@mui/material/Button";
import { Navigate, useNavigate } from "react-router-dom";
import Menu from "./Menu";
import { saveAs } from "file-saver";
import Autocomplete from "@mui/material/Autocomplete";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";
import TextareaAutosize from "@mui/material/TextareaAutosize";

export default function ChequeoElementos(props) {
  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    chequeoElementos,
    statusAcceso,
    statusAcceso3,
    localidades,
    guardarChequeoElementos,
    obtenerAcceso,
  } = serviciosContext;

  const handleChangePregunta1 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta1: event.target.checked,
    });
  };

  const handleChangePregunta2 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta2: event.target.checked,
    });
  };

  const handleChangePregunta3 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta3: event.target.checked,
    });
  };

  const handleChangePregunta4 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta4: event.target.checked,
    });
  };

  const handleChangePregunta5 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta5: event.target.checked,
    });
  };

  const handleChangePregunta6 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta6: event.target.checked,
    });
  };

  const handleChangePregunta7 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta7: event.target.checked,
    });
  };

  const handleChangePregunta8 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta8: event.target.checked,
    });
  };

  const handleChangePregunta9 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta9: event.target.checked,
    });
  };

  const handleChangePregunta10 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta10: event.target.checked,
    });
  };

  const handleChangePregunta11 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta11: event.target.checked,
    });
  };

  const handleChangePregunta12 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta12: event.target.checked,
    });
  };

  const handleChangePregunta13 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta13: event.target.checked,
    });
  };

  const handleChangePregunta14 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta14: event.target.checked,
    });
  };

  const handleChangePregunta15 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta15: event.target.checked,
    });
  };

  const handleChangePregunta16 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta16: event.target.checked,
    });
  };

  const handleChangePregunta17 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta17: event.target.checked,
    });
  };

  const handleChangePregunta18 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta18: event.target.checked,
    });
  };

  const handleChangePregunta19 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta19: event.target.checked,
    });
  };

  const handleChangePregunta20 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta20: event.target.checked,
    });
  };

  const handleChangePregunta21 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta21: event.target.checked,
    });
  };

  const handleChangePregunta22 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta22: event.target.checked,
    });
  };

  const handleChangePregunta23 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta23: event.target.checked,
    });
  };

  const handleChangePregunta24 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta24: event.target.checked,
    });
  };

  const handleChangePregunta25 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta25: event.target.checked,
    });
  };

  const handleChangePregunta26 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta26: event.target.checked,
    });
  };

  const handleChangePregunta27 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta27: event.target.checked,
    });
  };

  const handleChangePregunta28 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta28: event.target.checked,
    });
  };

  const handleChangePregunta29 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta29: event.target.checked,
    });
  };
  const handleChangePregunta30 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta30: event.target.checked,
    });
  };
  const handleChangePregunta31 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta31: event.target.checked,
    });
  };
  const handleChangePregunta32 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta32: event.target.checked,
    });
  };
  const handleChangePregunta33 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta33: event.target.checked,
    });
  };
  const handleChangePregunta34 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta34: event.target.checked,
    });
  };
  const handleChangePregunta35 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta35: event.target.checked,
    });
  };
  const handleChangePregunta36 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta36: event.target.checked,
    });
  };
  const handleChangePregunta37 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta37: event.target.checked,
    });
  };
  const handleChangePregunta38 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta38: event.target.checked,
    });
  };
  const handleChangePregunta39 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta39: event.target.checked,
    });
  };
  const handleChangePregunta40 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta40: event.target.checked,
    });
  };
  const handleChangePregunta41 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta41: event.target.checked,
    });
  };
  const handleChangePregunta42 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta42: event.target.checked,
    });
  };
  const handleChangePregunta43 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta43: event.target.checked,
    });
  };

  const handleChangePregunta44 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta44: event.target.checked,
    });
  };

  const handleChangePregunta45 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta45: event.target.checked,
    });
  };

  const handleChangePregunta46 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta46: event.target.checked,
    });
  };

  const handleChangePregunta47 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta47: event.target.checked,
    });
  };

  const handleChangePregunta48 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta48: event.target.checked,
    });
  };

  const handleChangePregunta49 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta49: event.target.checked,
    });
  };

  const handleChangePregunta50 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta50: event.target.checked,
    });
  };

  const handleChangePregunta51 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta51: event.target.checked,
    });
  };

  const handleChangePregunta52 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta52: event.target.checked,
    });
  };

  const handleChangePregunta53 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta53: event.target.checked,
    });
  };

  const handleChangePregunta54 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta54: event.target.checked,
    });
  };

  const handleChangePregunta55 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta55: event.target.checked,
    });
  };

  const handleChangePregunta56 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta56: event.target.checked,
    });
  };

  const handleChangePregunta57 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta57: event.target.checked,
    });
  };

  const handleChangePregunta58 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta58: event.target.checked,
    });
  };

  const handleChangePregunta59 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta59: event.target.checked,
    });
  };

  const handleChangePregunta60 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta60: event.target.checked,
    });
  };

  const handleChangePregunta61 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta61: event.target.checked,
    });
  };

  const handleChangePregunta62 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta62: event.target.checked,
    });
  };

  const handleChangePregunta63 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta63: event.target.checked,
    });
  };
  const handleChangePregunta64 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta64: event.target.checked,
    });
  };
  const handleChangePregunta65 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta65: event.target.checked,
    });
  };
  const handleChangePregunta66 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta66: event.target.checked,
    });
  };
  const handleChangePregunta67 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta67: event.target.checked,
    });
  };
  const handleChangePregunta68 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta68: event.target.checked,
    });
  };
  const handleChangePregunta69 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta69: event.target.checked,
    });
  };
  const handleChangePregunta70 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta70: event.target.checked,
    });
  };
  const handleChangePregunta71 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta71: event.target.checked,
    });
  };
  const handleChangePregunta72 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta72: event.target.checked,
    });
  };
  const handleChangePregunta73 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta73: event.target.checked,
    });
  };
  const handleChangePregunta74 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta74: event.target.checked,
    });
  };
  const handleChangePregunta75 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta75: event.target.checked,
    });
  };
  const handleChangePregunta76 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta76: event.target.checked,
    });
  };
  const handleChangePregunta77 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta77: event.target.checked,
    });
  };
  const handleChangePregunta78 = (event) => {
    guardarChequeoElementos({
      ...chequeoElementos,
      pregunta78: event.target.checked,
    });
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    return;
  };

  //console.log(chequeoElementos);

  return (
    <Fragment>
      <Fragment>
        <Grid
          container
          spacing={3}
          style={{ marginTop: "0vw", marginLeft: "0vw" }}
        >
          <Grid item xs={12} md={7} style={{ marginTop: "1vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta1 : null}
                    onChange={handleChangePregunta1}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Funcionamiento del grupo electrógeno con nafta e instrucciones de encendido y puesta en marcha con periodicidad semanal."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "0vw" }}>
            <TextField
              id="comentario1"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario1 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario1: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta2 : null}
                    onChange={handleChangePregunta2}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Comprobar luminaria."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario2"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario2 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario2: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta3 : null}
                    onChange={handleChangePregunta3}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Correcto funcionamiento de los termo y calefones para proveer adecuadamente agua caliente a todo el establecimiento. (Semanal)."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario3"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario3 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario3: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta4 : null}
                    onChange={handleChangePregunta4}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Control de funcionamiento de la bomba de agua, cisterna y tablero de comando. (semestral)."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario4"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario4 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario4: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta5 : null}
                    onChange={handleChangePregunta5}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Controlar el vencimiento de las obleas de los matafuegos. (anual)."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario5"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario5 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario5: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta6 : null}
                    onChange={handleChangePregunta6}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Funcionamiento de los equipos de calefacción y calderas comprobar correcto encendido en el mes de febrero, de lo contrario llamar al service, controlar la temperatura de los radiadores y purgarlos."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario6"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario6 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario6: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta7 : null}
                    onChange={handleChangePregunta7}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Probar funcionamiento de luces de emergencia, batería."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario7"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario7 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario7: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta8 : null}
                    onChange={handleChangePregunta8}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Central de incendio funcionando y en condiciones."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario8"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario8 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario8: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta9 : null}
                    onChange={handleChangePregunta9}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Detectores de humo y de gases controlan su funcionamiento."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario9"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario9 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario9: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta10 : null}
                    onChange={handleChangePregunta10}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Cartelería plástica y luminosa completa."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario10"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario10 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario10: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta11 : null}
                    onChange={handleChangePregunta11}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Croquis de evacuación y salidas de emergencia libres para la circulación."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario11"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario11 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario11: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta12 : null}
                    onChange={handleChangePregunta12}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Barrales antipánico, señalización y cintas antideslizantes."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario12"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario12 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario12: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta13 : null}
                    onChange={handleChangePregunta13}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Canaletas: 1 vez por semana o la proximidad de lluvias."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario13"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario13 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario13: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta14 : null}
                    onChange={handleChangePregunta14}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Techos y terrazas libres de cualquier objeto."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario14"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario14 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario14: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta15 : null}
                    onChange={handleChangePregunta15}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Patios: limpieza y corte de pasto quincenal (verano) mensual (invierno)."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario15"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario15 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario15: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta16 : null}
                    onChange={handleChangePregunta16}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Control de plagas, desratización, certificados según requerimiento."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario16"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario16 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario16: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta17 : null}
                    onChange={handleChangePregunta17}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Destape de cloacas y desagües mensualmente."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario17"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario17 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario17: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta18 : null}
                    onChange={handleChangePregunta18}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Módulos sanitarios funcionamiento y recarga."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario18"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario18 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario18: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta19 : null}
                    onChange={handleChangePregunta19}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Recintos de residuos comunes y patológicos libres y en correctas condiciones de higiene, paredes y pisos con cerámicos, con puerta y picaporte que cierre correctamente."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario19"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario19 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario19: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta20 : null}
                    onChange={handleChangePregunta20}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Tableros general en condiciones con tapa con indicación de peligro electricidad. Sectorizado con térmicas y disyuntores."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario20"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario20 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario20: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta21 : null}
                    onChange={handleChangePregunta21}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Tableros de sectores con tapa e indicación de peligro electricidad. Térmicas y disyuntores por zona. Bien identificados."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario21"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario21 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario21: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta22 : null}
                    onChange={handleChangePregunta22}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Tomas, enchufes íntegros, timbres, luminaria, puesta a tierra."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario22"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario22 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario22: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta23 : null}
                    onChange={handleChangePregunta23}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Lámparas de luminarias completas funcionando."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario23"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario23 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario23: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta24 : null}
                    onChange={handleChangePregunta24}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Ascensor, si posee, al detectar un mal funcionamiento llamar al servicio."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario24"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario24 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario24: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta25 : null}
                    onChange={handleChangePregunta25}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Oblea de control mensual."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario25"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario25 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario25: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta26 : null}
                    onChange={handleChangePregunta26}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Libro de mantenimiento actualizado."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario26"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario26 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario26: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta27 : null}
                    onChange={handleChangePregunta27}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Sala de maquina: con luz y matafuegos, con cierre por seguridad. Sin elementos ajenos prohibidos a la sala."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario27"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario27 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario27: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta28 : null}
                    onChange={handleChangePregunta28}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Grupos electrógenos mensual."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario28"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario28 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario28: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta29 : null}
                    onChange={handleChangePregunta29}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Sensores de humo."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario29"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario29 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario29: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta30 : null}
                    onChange={handleChangePregunta30}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Central de incendio mensual."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario30"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario30 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario30: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta31 : null}
                    onChange={handleChangePregunta31}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Luces de emergencia mensual."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario31"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario31 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario31: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta32 : null}
                    onChange={handleChangePregunta32}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Termotanques."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario32"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario32 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario32: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta33 : null}
                    onChange={handleChangePregunta33}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Calefones."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario33"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario33 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario33: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta34 : null}
                    onChange={handleChangePregunta34}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Puesta a tierra."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario34"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario34 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario34: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta35 : null}
                    onChange={handleChangePregunta35}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Control de módulos, teclas, tomas y enchufes."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={5} style={{ marginTop: "-1vw" }}>
            <TextField
              id="comentario35"
              label="COMENTARIO / DESVÍO"
              variant="standard"
              fullWidth
              value={chequeoElementos ? chequeoElementos.comentario35 : null}
              onChange={(e) => {
                guardarChequeoElementos({
                  ...chequeoElementos,
                  comentario35: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "0vw" }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={chequeoElementos ? chequeoElementos.pregunta36 : null}
                    onChange={handleChangePregunta36}
                    inputProps={{ "aria-label": "controlled" }}
                    value="1"
                    style={{ marginRight: "1vw" }}
                  />
                }
                label="Calefactores."
                labelPlacement="end"
                //disabled={chequeoElementos && statusAcceso !== 200}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={12} />
        </Grid>
      </Fragment>
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
